import React from 'react';
import PropTypes from 'prop-types';
import { mergeDeepRight } from 'ramda';
import { ComponentOverridesConsumer } from '@bubble-ui/provider-component-overrides';
import { SHOW_DEPRECATION_WARNINGS } from '@bubble-dev/build-config';

// Extracted directly from https://github.com/acdlite/recompose/blob/master/src/packages/recompose/getDisplayName.js
// The motivation is to stop having recompose around as a dependency
var getDisplayName = Component => {
  return Component.displayName || Component.name || 'Component';
};
var isDeprecatedOverride = name => !name.startsWith('ActionIcon') && !name.startsWith('ColoredIllustration') && !name.startsWith('FeedbackStateIcon') && !name.startsWith('Flag') && !name.startsWith('Icon') && !name.startsWith('KlarnaLogo') && !name.startsWith('NavigationIcon') && !name.startsWith('PaymentLogo') && !name.startsWith('Spot') && !['KlarnaAvatar', 'Loader'].includes(name);
export default function withProvisionalOverrideFromContext(Target) {
  var name = getDisplayName(Target);
  class WithPropsFromContext extends React.PureComponent {
    // @ts-expect-error

    render() {
      var Override = this.context[name];
      if (typeof Override === 'function') {
        if (SHOW_DEPRECATION_WARNINGS) {
          var deprecationWarning = "BUBBLE-UI DEPRECATION WARNING: Component overrides using React legacy context are deprecated and will be removed in version 6.0.0.";
          deprecationWarning += "\nUse 'ComponentOverridesProvider' to override assets instead.";
          console.warn(deprecationWarning);
        }
        return /*#__PURE__*/React.createElement(Override, this.props);
      } else if (Override != null) {
        if (SHOW_DEPRECATION_WARNINGS) {
          var _deprecationWarning = "BUBBLE-UI DEPRECATION WARNING: Prop overrides using React legacy context are deprecated and will be removed in version 6.0.0.";
          console.warn(_deprecationWarning);
        }
        return /*#__PURE__*/React.createElement(Target, mergeDeepRight(this.props, Override));
      }
      return /*#__PURE__*/React.createElement(ComponentOverridesConsumer, null, value => {
        if (Object.keys(value).includes(name)) {
          var override = value[name];
          if (SHOW_DEPRECATION_WARNINGS && isDeprecatedOverride(name)) {
            var _deprecationWarning2 = "BUBBLE-UI DEPRECATION WARNING: Component overrides for '".concat(name, "' are deprecated and will be removed in/by v6.0.0. From v6.0.0 on only visual assets can be overridden.");
            console.warn(_deprecationWarning2);
          }
          if (typeof override === 'function') {
            var _Override = override;
            return /*#__PURE__*/React.createElement(_Override, this.props);
          }
        }
        return /*#__PURE__*/React.createElement(Target, this.props);
      });
    }
  }

  // @ts-expect-error
  WithPropsFromContext.contextTypes = {
    [name]: PropTypes.any
  };

  // @ts-expect-error
  WithPropsFromContext.displayName = name;
  return WithPropsFromContext;
}
//# sourceMappingURL=index.js.map